import React, { useMemo } from 'react';

import { ApplicationMethodTypeId } from '../../../models/discount-models';
import { useDiscountWizardStateContext } from '../../state';
import { applicationMethodNames } from '../configure/use-application-methods';

import { SummaryCard } from './summary-card';

import type { SummaryCardProps } from './summary-card';

export function ConfigureCard({ onEditClick }: { onEditClick: () => void }) {
  const {
    configureStepState: { applicationMethod, discountCode, discountName, loyaltyPointsToRedeem },
  } = useDiscountWizardStateContext();

  const rows = useMemo(() => {
    const baseRows: SummaryCardProps['rows'] = [
      { fieldTitle: 'Discount name:', fieldValue: discountName },
      { fieldTitle: 'Application method:', fieldValue: applicationMethodNames[applicationMethod] },
    ];

    if (
      applicationMethod === ApplicationMethodTypeId.DutchieLoyalty ||
      applicationMethod === ApplicationMethodTypeId.ExternalLoyalty ||
      (applicationMethod === ApplicationMethodTypeId.Manually && !!loyaltyPointsToRedeem)
    ) {
      baseRows.push({ fieldTitle: 'Loyalty points to redeem:', fieldValue: loyaltyPointsToRedeem });
    }

    return discountCode !== ''
      ? [baseRows[0], { fieldTitle: 'Code:', fieldValue: discountCode }, ...baseRows.slice(1)]
      : baseRows;
  }, [applicationMethod, discountCode, discountName, loyaltyPointsToRedeem]);

  return <SummaryCard rows={rows} title='Configure' onEditClick={onEditClick} />;
}
